export default __webpack_public_path__ + "static/media/product-3.e556abe9.webp";